"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GeoHandler = void 0;
const React = require("react");
const react_1 = require("react");
const GeoContext_1 = require("../../contexts/GeoContext");
const useRetrieveLatLngByPostcode_1 = require("../../hooks/useRetrieveLatLngByPostcode");
const GeoHandler = ({ autoRequestLocation = true, children }) => {
    const [postcodeLatLong, setPostcodeLatLong] = (0, react_1.useState)();
    // whether an error occurred retrieving the lat/lng of a postcode
    // this can also occur on an invalid postcode
    const [postcodeLatLngRetrieveError, setPostcodeLatLngRetrieveError] = (0, react_1.useState)(false);
    // whether a postcode search is currently being performed
    const processingPostcodeLatLong = (0, react_1.useRef)(false);
    const [browserLatLong, setBrowserLatLong] = (0, react_1.useState)();
    // use browser's location services to get the lat long
    const requestBrowserLocation = (0, react_1.useCallback)(() => {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(position => {
                setBrowserLatLong({
                    lat: position.coords.latitude,
                    lng: position.coords.longitude
                });
            });
        }
    }, []);
    (0, react_1.useEffect)(() => {
        if (autoRequestLocation) {
            requestBrowserLocation();
        }
    }, [autoRequestLocation]);
    const setByPostcode = (0, react_1.useCallback)(async (postcode) => {
        // if postcode is clear also remove the error state
        if (!postcode) {
            setPostcodeLatLngRetrieveError(false);
        }
        // do not spam retrieve requests
        if (processingPostcodeLatLong.current) {
            console.warn("already searching for postcode lat/lng");
            return;
        }
        // retrieve current lat/lng for postcode
        processingPostcodeLatLong.current = true;
        const latLng = await retrieveLatLngByPostcode(postcode);
        setPostcodeLatLong(latLng);
    }, [processingPostcodeLatLong]);
    // hook helper to retrieve postcode lat/lng
    const { mutate: retrieveLatLngByPostcode, isLoading: isRetrievingLatLngByPostCode } = (0, useRetrieveLatLngByPostcode_1.useRetrieveLatLngByPostcode)({
        onSuccess: (latLng) => {
            // reset error state
            setPostcodeLatLngRetrieveError(false);
            // return postcode lat/ln
            return latLng;
        },
        onSettled: () => {
            // stop processing current request
            processingPostcodeLatLong.current = false;
        },
        onError: () => {
            // set error state
            setPostcodeLatLngRetrieveError(true);
        }
    });
    // determine the current approach for determining the lat-long
    const latLng = (0, react_1.useMemo)(() => {
        // postcode manually entered, so it takes preference
        if (postcodeLatLong)
            return postcodeLatLong;
        // browser is reasonable fallback
        if (browserLatLong)
            return browserLatLong;
        return null;
    }, [postcodeLatLong, browserLatLong]);
    const provider = {
        latLng,
        setByPostcode,
        clearByPostcode: () => setPostcodeLatLong(null),
        setByBrowser: requestBrowserLocation,
        clearByBrowser: () => setBrowserLatLong(null),
        postcodeLatLngRetrieveError,
        setPostcodeLatLngRetrieveError,
        isRetrievingLatLngByPostCode
    };
    return React.createElement(GeoContext_1.GeoContext.Provider, { value: provider }, children);
};
exports.GeoHandler = GeoHandler;
//# sourceMappingURL=index.js.map